import { render, staticRenderFns } from "./Chapter.vue?vue&type=template&id=1ff7d60c&scoped=true&lang=html&"
import script from "./Chapter.vue?vue&type=script&lang=ts&"
export * from "./Chapter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff7d60c",
  null
  
)

export default component.exports